import { render } from "./GroupProfilePhotoSetting.vue?vue&type=template&id=f6cbcd36"
import script from "./GroupProfilePhotoSetting.vue?vue&type=script&lang=js"
export * from "./GroupProfilePhotoSetting.vue?vue&type=script&lang=js"
script.render = render

export default script